import moment from 'moment';
export class DateUtils {
  static isBefore(date: Date, days: number): boolean {
    const daysBefore = moment().subtract(days, 'days');
    return moment(date, 'YYYY-MM-DD').isBefore(daysBefore.format('YYYY-MM-DD'));
  }
}
